import React from 'react'
import { Users } from 'lucide-react'
import GenericTable from '../../components/GenericTable'

const AdminCustomers = () => {
  return (
    <GenericTable
      tableName="customers"
      title="Customers"
      icon={Users}
      iconColor="blue"
      searchFields={['customer_number', 'first_name', 'last_name', 'email', 'mobile_phone']}
      hiddenFields={['customer_id', 'created_at', 'updated_at', 'password_hash', 'national_id_hash', 'record_version']}
      primaryKey="customer_id"
      defaultFields={['customer_number', 'first_name', 'last_name', 'email', 'mobile_phone', 'customer_status', 'city', 'state', 'date_of_birth']}
      addFields={['first_name', 'last_name', 'email', 'mobile_phone', 'date_of_birth', 'address_line1', 'city', 'state', 'postal_code', 'gender', 'marital_status']}
      editFields={[
        'first_name', 'last_name', 'middle_name', 'email', 'mobile_phone', 'home_phone',
        'date_of_birth', 'address_line1', 'address_line2', 'city', 'state', 'postal_code', 'country',
        'gender', 'marital_status', 'occupation', 'annual_income_band', 'employer_name',
        'customer_status', 'risk_band', 'segment', 'preferred_channel', 'preferred_language',
        'smoker_flag', 'pre_existing_condition_flag', 'maternity_eligible_flag',
        'email_opt_in', 'sms_opt_in', 'whatsapp_opt_in', 'do_not_call_flag',
        'alt_contact_name', 'alt_contact_phone', 'source_of_funds'
        // Excluded system fields: customer_id, customer_number, created_at, updated_at, 
        // password_hash, national_id_hash, record_version, last_login_at, login_id, external_ref
      ]}
    />
  )
}

export default AdminCustomers